import axios from "axios";
import { getToken } from "../Utlis/UpdateUsersState";

const login = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/token/`,
      data
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const refresh = async (refresh) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/token/refresh/`,
      { refresh },
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const resendVerificationEmail = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/resend-verification/`,
      {},
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const verifyEmail = async (id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}auth/verify-email/${id}/`
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const forgotPasswordAPI = async (email) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/forgot-password/`,
      { email }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const resetPasswordAPI = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/reset-password/`,
      data
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

export {
  login,
  refresh,
  resendVerificationEmail,
  verifyEmail,
  forgotPasswordAPI,
  resetPasswordAPI,
};
